"use client";

import { sendGA4Event } from "analytics/ga4-helper";
import classNames from "classnames";
import useSafeRouter from "hoc/useSafeRouter";
import { RootState } from "interfaces/generics.type";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import openLiveChat from "util/chat-widget/open-live-chat";
import { getChatOnlineTime } from "util/date-helper";
import { isProductPage } from "modules/product/product-helper";
import { CHECKOUT_PAGE } from "util/product/product-constants";
import styles from "./pa-chat-widget.module.scss";

function PAChatWidgetIcon() {
  const currentPageType = useSelector((state: RootState) => state.utils.currentPageType);
  const { refreshStatus } = useSelector((store: RootState) => store.authenticationState);
  const { query } = useSafeRouter();
  const online = getChatOnlineTime();

  useEffect(() => {
    if (!document.getElementById("rasaWebchatPro")) {
      return;
    }
    if (currentPageType === CHECKOUT_PAGE) {
      document.getElementById("rasaWebchatPro").style.display = "none";
    } else {
      document.getElementById("rasaWebchatPro").style.display = "block";
    }
  }, [currentPageType]);

  useEffect(() => {
    if (!document.getElementById("rasaWebchatPro")) {
      if ("chatnow" in query && refreshStatus === "complete") {
        openLiveChat();
      }
    }
  }, [refreshStatus]);

  function handleOpenChatWidget() {
    sendGA4Event("chat_opened", {
      url: window.location.href,
    });
    openLiveChat();
  }

  if (currentPageType === CHECKOUT_PAGE) {
    return null;
  }

  return (
    <div>
      <div className={`${styles.pa_widget_icon} ${isProductPage(currentPageType) ? styles.product_page_css : ""}`} onClick={handleOpenChatWidget}>
        <i className="fa fa-comments" />
        <span className={classNames(styles.chat_status, {
          [styles.online]: online,
        })}
        />
      </div>
      {/* {online && showPopover && renderToolTip()} */}
    </div>
  );
}

export default PAChatWidgetIcon;
